export const API_PATHS = {
  // form
  FORM_BLOCKS: (id: string) => `/api/v1/form/${id}/blocks`,
  POST_ANSWER: "/api/v1/form/answer",
  // check in
  DEPRECATED_CHECK_IN_BLOCKS: (id: string) => `/api/v1/form/${id}/check-in`,
  CHECK_IN_BLOCKS: (id: string) => `/api/v1/form/monthly-check-in/${id}`,
  CHECK_IN_OPEN_EVENT: (id: string) => `/api/v1/form/monthly-check-in/${id}/events/open`,
  // quiz
  QUIZ_BLOCKS: (id: string) => `/api/v1/quiz/${id}/blocks`,
  // QUIZ_POST_ANSWER: "/api/v1/quiz/answer",

  UPLOAD_DOCUMENT: "/api/v1/documents/upload",
  VERIFY_CONTACTS: "/api/v1/form/verify-contacts",

  // samsub
  GET_ACCESS_TOKEN: "/api/v1/sumsub/access-token",

  // vouched
  VERIFY_SSN: "/api/v1/vouched/verify-ssn",
};
